import type { PatientInvoiceKind } from './middleware-types'

/** Field/row labels per patient invoice kind — docs/GLOSSARY.md "Billing" terms. */
export const PATIENT_INVOICE_KIND_LABELS: Record<PatientInvoiceKind, string> = {
  copay: 'Co-pay',
  deductible: 'Deductible',
  coinsurance: 'Co-insurance',
  'self-pay': 'Self-pay',
}
